import { useAuth } from "@/providers/auth-provider";
import { useModal } from "@/providers/modal-provider";
import { ArrowRightIcon } from "lucide-react";
import Link from "next/link";
import { useState } from "react";

const items = [
	{ id: 1, label: "Submit Your Product" },
	{ id: 2, label: "Looking for Funding ?" },
];

function AnimatedButton() {
	const { isLoggedIn } = useAuth();
	const { openAuthModal } = useModal();
	const [currentItem] = useState(items[0]);

	return !isLoggedIn ? (
		<button
			onClick={() => openAuthModal()}
			className="flex w-full items-center justify-center gap-1 rounded bg-[#FFA804] py-2 text-sm font-semibold transition hover:bg-[#de9102] active:bg-[#de9102] lg:w-[220px]"
		>
			{currentItem.label}

			{currentItem === items[0] && <ArrowRightIcon className="h-4 w-4 text-inherit" />}
		</button>
	) : (
		<Link
			href="/products/form/getting-started"
			target="_blank"
			className="flex w-full items-center justify-center gap-1 rounded bg-[#FFA804] py-2 text-sm font-semibold transition hover:bg-[#de9102] active:bg-[#de9102] lg:w-[220px]"
		>
			{currentItem.label}

			{currentItem === items[0] && <ArrowRightIcon className="h-4 w-4 text-inherit" />}
		</Link>
	);
}

export default AnimatedButton;
